import { GetDashboardData } from 'domain/usecases/get-dashboard-data';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetDashboardData extends BaseHttpService<GetDashboardData.Model> implements GetDashboardData {
  async get(params: GetDashboardData.Params): Promise<GetDashboardData.Model> {
    return await this.request('get', {}, params);
  }
}
